import TodoStatusEnum from '@/enums/TodoStatus.enum'
import TodoTypesEnum from '@/enums/todo-types.enum'
import lang from '@/lang'
import moment from 'moment'

export const todoStateMap = (type) => new Map([
  [TodoStatusEnum.OPEN, lang.open],
  [TodoStatusEnum.DUE, lang.todoList.stateLabels.due],
  [TodoStatusEnum.DONE, lang.todoList.stateLabels.done[type]],
  [TodoStatusEnum.DECLINED, lang.todoList.stateLabels.declined],
  [TodoStatusEnum.OVERDUE, lang.todoList.stateLabels.overdue],
])

export const todoTypeMap = new Map([
  [TodoTypesEnum.ATTENTION, lang.todoList.typeLabels[TodoTypesEnum.ATTENTION]],
  [TodoTypesEnum.PROCESS, lang.todoList.typeLabels[TodoTypesEnum.PROCESS]],
  [TodoTypesEnum.RELEASE, lang.todoList.typeLabels[TodoTypesEnum.RELEASE]],
  [TodoTypesEnum.SIGNATURE, lang.todoList.typeLabels[TodoTypesEnum.SIGNATURE]],
])

/**
 * return the state of a todo item.
 * @param {import('@/modules/todo/todoService').Todo} todoItem - contains all necessary props.
 */
const getState = (todoItem) => {
  const { status, dueFromDate: dueFrom, dueToDate: dueTo } = todoItem

  if (status === TodoStatusEnum.OPEN && dueTo && dueFrom) {

    const dueToDate = moment(dueTo)
    const dueFromDate = moment(dueFrom)

    // from is today or older and to date is today or in the future
    if (dueFromDate <= moment().endOf('day') && dueToDate >= moment().startOf('day')) {
      return TodoStatusEnum.DUE
    } else
    // to date is in the past
    if (dueToDate < moment().startOf('day')) {
      return TodoStatusEnum.OVERDUE
    }
  }

  return status
}

export default getState
